export default __webpack_public_path__ + "static/media/icefloor.b262395a.png";